export const apiBilibiliCover = async (szUrl)=>{
    const videoId = getVideoId(szUrl);
    if (!videoId)return '';
    // 调用 Bilibili API 获取视频信息
    return new Promise(resolve => {
        fetch(`https://api.bilibili.com/x/web-interface/view?bvid=${videoId}`)
            .then(response => response.json())
            .then(data => {
                if (data.code === 0) {
                    // const coverUrl = data.data.pic; // 视频封面 URL
                    resolve(data.data);
                    // console.log('视频封面 URL:', coverUrl);
                    //
                    // // 显示封面
                    // const img = document.createElement('img');
                    // img.src = coverUrl;
                    // document.body.appendChild(img);
                } else {
                    console.error('获取视频信息失败:', data.message);
                }
            })
            .catch(error => {
                console.error('请求失败:', error);
            });
    })

}

function getVideoId(url) {
    // 匹配 BV 号
    const bvPattern = /(BV[0-9A-Za-z]{10})/;
    // 匹配 AV 号
    const avPattern = /(av\d+)/i;

    // 检查 BV 号
    const bvMatch = url.match(bvPattern);
    if (bvMatch) {
        return bvMatch[1]; // 返回 BV 号
    }

    // 检查 AV 号
    const avMatch = url.match(avPattern);
    if (avMatch) {
        return avMatch[1]; // 返回 AV 号
    }

    // 如果没有匹配到，返回 null
    return null;
}

export function fetchPageTitle(link: string) {
    return new Promise(resolve => {
        fetch(link)
            .then(async (result) => {
                try {
                    const szHtml = await result.text();
                    // 使用DOMParser解析HTML字符串
                    const doc = new DOMParser().parseFromString(szHtml, "text/html");
                    const szTitle =
                        doc.title ||
                        doc.querySelector('meta[property="og:title"]')?.getAttribute("content") ||
                        doc.querySelector('meta[name="og:title"]')?.getAttribute("content") ||
                        doc.querySelector('meta[name="title"]')?.getAttribute("content") ||
                        "";
                    resolve(szTitle);
                }catch (e) {
                    resolve('')
                }
            })
            .catch(() => {});
    })

}